"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const card_1 = require("./card");
const seedrandom_1 = __importDefault(require("seedrandom"));
class Pile {
    constructor(cards) {
        this.cards = [];
        this.cards = cards.map(c => (typeof c === 'string' ? card_1.Card.fromValueString(c) : new card_1.Card(c)));
    }
    shuffle(seed) {
        const rng = seedrandom_1.default(seed);
        for (let i = this.cards.length - 1; i > 0; i--) {
            const j = Math.floor(rng() * (i + 1));
            [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
        }
        return this; // chainable
    }
    get size() {
        return this.cards.length;
    }
    get top() {
        return this.cards[this.cards.length - 1];
    }
    drawOne() {
        const card = this.cards.pop();
        if (!card) {
            throw new Error('NO_CARDS_LEFT');
        }
        return card;
    }
    add(card) {
        this.cards.push(card);
    }
    toJSON() {
        return this.cards.map(c => c.toJSON());
    }
}
exports.Pile = Pile;
//# sourceMappingURL=pile.js.map